var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.5665C16.1778 12.5665 16.3444 12.5942 16.5 12.6498C16.6556 12.7054 16.8 12.7998 16.9333 12.9331L23.0667 19.0665C23.3111 19.3109 23.4333 19.622 23.4333 19.9998C23.4333 20.3776 23.3111 20.6887 23.0667 20.9331C22.8222 21.1776 22.5111 21.2998 22.1333 21.2998C21.7556 21.2998 21.4444 21.1776 21.2 20.9331L16 15.7331L10.8 20.9331C10.5556 21.1776 10.2444 21.2998 9.86667 21.2998C9.48889 21.2998 9.17778 21.1776 8.93333 20.9331C8.68889 20.6887 8.56667 20.3776 8.56667 19.9998C8.56667 19.622 8.68889 19.3109 8.93333 19.0665L15.0667 12.9331C15.2 12.7998 15.3444 12.7054 15.5 12.6498C15.6556 12.5942 15.8222 12.5665 16 12.5665Z",
    fill: "#0E88FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.38249231cc21a4a4315c0f0fb15f01a2.svg";
export { ForwardRef as ReactComponent };